export const DOWNLOAD_LINKS = {
    GET_IT_ON: 'GET IT ON',
    GOOGLE_PLAY: 'Google Play',
    DOWNLOAD_ON_THE: 'Download on the',
    APP_STORE: 'App Store',
    GOOGLE_PLAY_ICON: '../../../../../assets/images/playStore.svg',
    APP_STORE_ICON: '../../../../../assets/images/apple icon.svg',
    APP_STORE_LINK: 'https://apps.apple.com/us/app/topfans-go-direct-to-fan/id6746835065',
    GOOGLE_PLAY_LINK: 'https://play.google.com/store/apps/details?id=app.topfans.com&pcampaignid=web_share'
}